import { cn } from '@/lib/utils'

interface SectionHeadingProps {
  id?: string
  title: string
  description?: string
  descriptionClassName?: string
  label?: string
  align?: 'left' | 'center'
  className?: string
  titleClassName?: string
  size?: 'default' | 'large'
}

export function SectionHeading({
  id,
  title,
  description,
  descriptionClassName,
  label,
  align = 'center',
  className,
  titleClassName,
  size = 'default',
}: SectionHeadingProps) {
  return (
    <div
      id={id}
      className={cn(
        'mx-auto max-w-3xl',
        align === 'center' && 'text-center',
        className,
      )}
    >
      {label && (
        <span className="mb-4 inline-block rounded-full bg-maia/10 px-3 py-1 text-xs font-bold uppercase tracking-widest text-maia-dark">
          {label}
        </span>
      )}
      <h2
        className={cn(
          'font-display font-bold leading-[1.05] tracking-tight text-ink',
          size === 'large'
            ? 'text-[clamp(2.25rem,6vw,4rem)]'
            : 'text-[clamp(1.75rem,4vw,3rem)]',
          titleClassName,
        )}
      >
        {title}
      </h2>
      {description && (
        <p
          className={cn(
            'mt-5 text-lg leading-relaxed text-muted md:text-xl',
            descriptionClassName,
          )}
        >
          {description}
        </p>
      )}
    </div>
  )
}
